import { OfflineRequestError } from 'utils/errorCodes'
import { ApiRequestQueue } from './api/queue'
import { ApiRequestStatus, ApiRequestType } from './api/queue/types'
import { serviceCenterPlannedNodesReposition } from './api/serviceCenterPlannedNodesReposition'

export const repositionPlannedNodes = async (
  param: { [plannedNodeId: number]: string },
  propertyId: number,
) => {
  const payload = {
    pseudonodes: param,
    propertyId,
  }

  try {
    // Request may or may not have been completed by the time the promise resolves
    const { status } = await ApiRequestQueue.createRequest(ApiRequestType.REPOSITION_PSEUDO_NODES, payload)

    if (status === ApiRequestStatus.COMPLETED) return
  } catch (error) {
    // If the request failed because the app is offline, don't throw an error
    if (!(error instanceof OfflineRequestError)) {
      throw error
    }
  }

  serviceCenterPlannedNodesReposition.callback(payload)
}
